import { render, staticRenderFns } from "./sellerList.vue?vue&type=template&id=6829bb22&"
import script from "./sellerList.vue?vue&type=script&lang=js&"
export * from "./sellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports